import { useEffect, useState } from "react";

import { redirectToSignIn, xboxOnboardSiteLocationPrefix } from "../constants";

const invitationsApiUrl = `${xboxOnboardSiteLocationPrefix}/invitations/api`;

export const useAutomaticInvitationEntry = (enabled: boolean): boolean | null => {
  const [shouldAutoOpenInvitations, setShouldAutoOpenInvitations] = useState<boolean | null>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    let active = true;
    setShouldAutoOpenInvitations(null);

    const checkInvitations = async () => {
      try {
        const response = await fetch(`${invitationsApiUrl}/automatic-entry`, {
          cache: "no-store",
        });
        if (response.status === 401 || response.redirected) {
          redirectToSignIn();
          return;
        }
        if (!response.ok) {
          throw new Error(`Failed to check invitations: ${response.status}`);
        }

        const { shouldAutoOpenInvitations: shouldOpen } = (await response.json()) as {
          shouldAutoOpenInvitations: boolean;
        };
        if (active) {
          setShouldAutoOpenInvitations(shouldOpen);
        }
      } catch (error) {
        console.error("Failed to check automatic invitation entry", error);
        if (active) {
          setShouldAutoOpenInvitations(false);
        }
      }
    };

    checkInvitations();

    return () => {
      active = false;
    };
  }, [enabled]);

  return enabled ? shouldAutoOpenInvitations : false;
};
